import React, { useEffect, useState } from "react";
import {
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Box,
  Paper,
  TablePagination,
} from "@mui/material";
import AlertMessage from "../common/AlertMessage";
import { getStorageValue } from "../../utils/helper";
import { useNavigate } from "react-router";
import PackageListings from "../../utils/services/PackageListing.api";
import { validateDate } from "../../utils/helper";
import { tableHeaders } from "../../data/UsersPage";
import NoDataFound from "../common/NoDataFound";
import Loaders from "../common/Loaders";

const statusMapping = {
  Unassigned: 1,
  Assigned: 2,
  "In-Transit": 3,
  Delivered: 4,
  Expired: 5,
};

const UserListingTable = ({
  searchParams,
  filterParams,
  userData,
  tab,
  statusId,
}) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [pgNo, setPgNo] = useState(0);
  const [pgSize, setPgSize] = useState(localStorage.getItem("PageSize") ? localStorage.getItem("PageSize") : 10);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [statusName, setStatusName] = useState(statusId)
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const CurrentLatitude = getStorageValue("latitude");
  const CurrentLongitude = getStorageValue("longitude");
  const navigate = useNavigate();

  // API Call to get Table data
  const getListingData = async () => {
    setLoading(true);
    const acceptedBy = tab === 0 ? userData?.userId : undefined;
    const requestedBy = tab === 1 ? userData?.userId : undefined;
    const type = statusMapping[statusId];
    const roleId = "";
    const response = await PackageListings.getPackageListing(
      roleId,
      type,
      pgNo + 1,
      pgSize,
      searchParams,
      filterParams,
      CurrentLatitude,
      CurrentLongitude,
      acceptedBy,
      requestedBy
    );
    if (response.status !== "success") {
      setLoading(false);
      if(response.error.response.status === 401) {
        navigate("/")
      } else {
        setAlertSeverity(response.status);
        setAlertMessage(
          response?.error?.response?.data?.title
            ? response?.error?.response?.data?.title
            : response.message
        );
        setOpen(true);
      }
    } else {
      setLoading(false);
      setData(response.data.packageList);
      setTotalData(response.data.count);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  // PAGINATION FUNCTIONS
  const handlePageChange = (e, newPage) => {
    setPgNo(newPage);
  };

  const handleRowsChange = (e) => {
    setPgSize(e.target.value);
    setPgNo(0);
    localStorage.setItem("PageSize", e.target.value);
  };

  const handleNavigate = (packagePin) => {
    navigate(`/packagedetails/${packagePin}`, {
      state: {
        backURL: `/users/${userData?.userId}`,
        tab,
        statusId,
        userData,
      },
    });
  };

  useEffect(() => {
    if(statusId !== statusName) {
      setPgNo(0);
      setStatusName(statusId)
    }
    getListingData();
    // eslint-disable-next-line
  }, [searchParams, pgNo, pgSize, filterParams, tab, statusId]);

  return (
    <>
      {loading && (
        <Loaders />
      )}
      {!loading && <TableContainer component={Paper} sx={{ border: "1px solid #E4E7EC", maxHeight: "610px", minHeight: '600px'}}>
        <Table sx={{ minWidth: 650 }} stickyHeader aria-label="users listing table">
          <TableHead>
            <TableRow>
              {tableHeaders.map((ele) => {
                return (
                  <>
                    {
                      <TableCell sx={{ fontSize: "13px", fontWeight: "600" }}>
                        {ele}
                      </TableCell>
                    }
                  </>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, idx) => (
              <TableRow
                onClick={() => handleNavigate(row.packagePin)}
                key={row.packageId}
                sx={{ height: "55px" }}
              >
                <TableCell sx={{ fontSize: "12px", padding: "0px 14px" }} component="th" scope="row">
                  {row.title}
                </TableCell>
                <TableCell sx={{ fontSize: "12px", padding: "0px 14px" }} component="th" scope="row">
                  {row.sourceCity}
                </TableCell>
                <TableCell sx={{ fontSize: "12px", padding: "0px 14px" }} component="th" scope="row">
                  {row.destinationCity}
                </TableCell>
                <TableCell sx={{ fontSize: "12px", padding: "14px 14px", width: "17%", wordBreak: "break-word" }} component="th" scope="row">
                  {row.sender}
                </TableCell>
                <TableCell sx={{ fontSize: "12px", padding: "0px 14px" }} component="th" scope="row">
                  {row.weight}
                </TableCell>
                <TableCell sx={{ fontSize: "12px", padding: "0px 14px" }} component="th" scope="row">
                  {validateDate(row.expiryDate)}
                </TableCell>
              </TableRow>
            ))}
            {!loading && data?.length === 0 && (
              <TableRow width="100%">
                <TableCell width="100%" colSpan={5} sx={{ padding: "10rem" }}>
                  <NoDataFound />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      }
      {!loading && <Box>
        <TablePagination
          component="div"
          count={totalData}
          page={pgNo}
          onPageChange={handlePageChange}
          rowsPerPage={pgSize}
          onRowsPerPageChange={handleRowsChange}
        />
      </Box>}

      <AlertMessage
        open={open}
        handleClose={handleClose}
        message={alertMessage}
        severity={alertSeverity}
      />
    </>
  );
};

export default React.memo(UserListingTable);
